import { Modal, notification } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { captureError } from '../../pages/captureError';
import { track } from '../../tracking';

const PatientPicModal: React.FC<{
    closeCameraModal: () => void;
    openCameraModal: boolean;
    setPic: (file?: File) => void;
}> = ({ closeCameraModal, setPic, openCameraModal }) => {
    const webcamRef = useRef<any>();

    const onClickStartCamera = async () => {
        try {
            const webcamElement = document.getElementById('video');
            const canvasElement = document.getElementById('canvas');

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const webcam = new Webcam(webcamElement, 'user', canvasElement);
            webcamRef.current = webcam;

            webcam
                .start()
                .then((result: any) => {
                    console.log('webcam started');
                })
                .catch((err: Error) => {
                    console.error(err);
                });
        } catch (error) {
            notification.error({
                message: 'Webcam failed to start.',
                placement: 'bottomRight',
                duration: 5,
            });
            track('ERROR', { on: 'PatientPicModal', what: (error as Error).message });
            captureError(error as Error);
            console.error(error);
        }
    };

    useEffect(() => {
        onClickStartCamera();
    }, []);

    const closeImageStream = () => {
        webcamRef?.current?.stop();
    };

    const onClickAndSave = async () => {
        try {
            const picture = webcamRef.current.snap();
            closeCameraModal();
            closeImageStream();

            if (picture) {
                const base64Response = await fetch(picture);
                const blob = await base64Response.blob();

                const file = new File([blob], 'patient', {
                    type: 'image/png',
                });
                setPic(file);
            } else {
                setPic(undefined);
            }
        } catch (e) {
            track('ERROR', { on: 'Save patient image', what: (e as Error).message });
            console.error(e);
        }
    };

    const closeImageModal = () => {
        closeImageStream();
        closeCameraModal();
    };

    return (
        <Modal
            title="Take pic"
            visible={openCameraModal}
            onCancel={closeImageModal}
            okText={'Save'}
            bodyStyle={{
                padding: '8px',
            }}
            footer={null}
            destroyOnClose={true}
            centered
        >
            <div className="flex flex-col justify-center space-y-8">
                <div className="flex w-full justify-center">
                    <div>
                        <video
                            id="video"
                            className="h-auto w-full"
                            autoPlay
                            playsInline
                            width="640"
                            height="480"
                        ></video>
                        <canvas id="canvas" className="h-auto w-full hidden"></canvas>
                    </div>
                </div>

                <div className="flex justify-end">
                    <button
                        className="primary-btn px-12 py-8 btn--small space-x-8 cursor-pointer"
                        onClick={onClickAndSave}
                    >
                        <span className="w-full text-center">Click Photo</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            className="w-24 fill-white"
                        >
                            <path d="M192 112H64c-8.8 0-16 7.2-16 16v64H156.1c23.5-29.3 59.5-48 99.9-48s76.5 18.7 99.9 48H464V96c0-8.8-7.2-16-16-16H271.1c-2.5 0-4.9 .6-7.2 1.7l-50.5 25.2c-6.7 3.3-14 5.1-21.5 5.1zM48 240V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V240H380c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H48zM0 416V128C0 92.7 28.7 64 64 64l0-16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64h32l50.5-25.2c8.9-4.4 18.7-6.8 28.6-6.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM336 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PatientPicModal;
